import { render, staticRenderFns } from "./MPReadOnly.vue?vue&type=template&id=e9dcf334&"
import script from "./MPReadOnly.vue?vue&type=script&lang=js&"
export * from "./MPReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports